import redCleaner from '../assets/red-cleaner.jpg';
import blueCleaner from '../assets/blue-cleaner.jpg';
import combo6L from '../assets/combo-6l.jpg';
import combo10L from '../assets/combo-10l.jpg';
import combo16L from '../assets/combo-16l.jpg';
import bannerRed from '../assets/banner-red.png';
import bannerBlue from '../assets/banner-blue.png';

export const products = [
    {
        id: 'combo-6l',
        name: 'Super Dhamaka Combo (6 Litres)',
        subtitle: '3 Red + 3 Blue Liquids',
        description: 'Super Combo Offer! Get 6 Litres combo (3 Red Multi Cleaner + 3 Blue Salt Cleaner) for just ₹1400!',
        price: '₹1400',
        originalPrice: '₹1800',
        unit: '6 Litres',
        image: combo6L,
        banner: combo6L,
        color: 'from-amber-500 via-orange-500 to-indigo-600',
        bgColor: 'from-amber-50 via-orange-50 to-blue-50',
        isSpecialOffer: true,
        isPopular: true,
        features: [
            '3 Red Liquids (3 రెడ్ లిక్విడ్ - ₹350/Liter)',
            '3 Blue Liquids (3 బ్లూ లిక్విడ్ - ₹250/Liter)',
            'Deep Cleaning for Marble & Tiles',
            'Commode & Floor Stain Specialist'
        ],
        useCases: [
            'Complete Bathroom & Toilet Deep Cleaning',
            'Marble, Granite & Tile Stain Removal',
            'Hard Water & Scale Deposit Cleaning'
        ],
        instructions: [
            'Use Red liquid for white marble & hard cement stains',
            'Use Blue liquid for hard salt stains & general tile cleaning'
        ],
        precautions: [
            'Wear gloves during application',
            'Keep out of reach of children',
            'Store in a cool, dry place'
        ]
    },
    {
        id: 'combo-10l',
        name: 'Mega Dhamaka Combo (10 Litres)',
        subtitle: '5 Red + 5 Blue Liquids',
        description: 'Mega 10 Litres combo (5 Red Multi Cleaner + 5 Blue Salt Cleaner) for just ₹2000!',
        price: '₹2000',
        originalPrice: '₹3000',
        unit: '10 Litres',
        image: combo10L,
        banner: combo10L,
        color: 'from-orange-500 via-red-600 to-amber-500',
        bgColor: 'from-orange-50 via-red-50 to-amber-50',
        isSpecialOffer: true,
        isBestValue: true,
        features: [
            '5 Red Liquids (5 రెడ్ లిక్విడ్ - ₹350/Liter)',
            '5 Blue Liquids (5 బ్లూ లిక్విడ్ - ₹250/Liter)',
            'Deep Cleaning for Marble & Tiles',
            'Commode & Floor Stain Specialist'
        ],
        useCases: [
            'Whole House & Bulk Cleaning Requirement',
            'Commercial & Residential Deep Cleaning',
            'Stubborn Salt & Cement Stain Removal'
        ],
        instructions: [
            'Use Red liquid for white marble & hard cement stains',
            'Use Blue liquid for hard salt stains & general tile cleaning'
        ],
        precautions: [
            'Wear gloves during application',
            'Keep out of reach of children',
            'Store in a cool, dry place'
        ]
    },
    {
        id: 'combo-16l',
        name: 'Jumbo Bumper Combo (16 Litres)',
        subtitle: '8 Red + 8 Blue Liquids',
        description: 'Jumbo Bumper 16 Litres combo (8 Red Multi Cleaner + 8 Blue Salt Cleaner) for just ₹3200!',
        price: '₹3200',
        originalPrice: '₹4800',
        unit: '16 Litres',
        image: combo16L,
        banner: combo16L,
        color: 'from-red-600 via-purple-600 to-pink-600',
        bgColor: 'from-red-50 via-purple-50 to-pink-50',
        isSpecialOffer: true,
        isBumperOffer: true,
        features: [
            '8 Red Liquids (8 రెడ్ లిక్విడ్ - ₹350/Liter)',
            '8 Blue Liquids (8 బ్లూ లిక్విడ్ - ₹250/Liter)',
            'Deep Cleaning for Marble & Tiles',
            'Commode & Floor Stain Specialist'
        ],
        useCases: [
            'Large Houses, Commercial & Bulk Usage',
            'Full Year Deep Cleaning Stock',
            'Heavy Duty Marble, Tile & Salt Stain Removal'
        ],
        instructions: [
            'Use Red liquid for white marble & hard cement stains',
            'Use Blue liquid for hard salt stains & general tile cleaning'
        ],
        precautions: [
            'Wear gloves during application',
            'Keep out of reach of children',
            'Store in a cool, dry place'
        ]
    },
    {
        id: 'red-cleaner',
        name: 'YahYah Sparkle Red',
        subtitle: 'Advanced Multi Cleaner for Deep Clean',
        description: 'Advanced Red Multi Cleaner for deep clean. Specially formulated for white marble, tiles, toilets, and removing hard cement marks.',
        price: '₹350',
        unit: '1 Litre',
        image: redCleaner,
        banner: bannerRed,
        color: 'from-red-500 to-orange-500',
        bgColor: 'from-red-50 to-orange-50',
        features: [
            'Remove hard cement marks',
            'Strong on dirt, safe on skin',
            'The commode stain specialist'
        ],
        useCases: [
            'White Marble Cleaning',
            'Buckets & Doors Cleaning',
            'Tiles & Floor Cleaning',
            'Toilet Cleaning',
            'Hard Cement Cleaning'
        ],
        instructions: [
            'Use green scrubber while cleaning',
            'Use steel scrubber',
            'Use sand paper (after pouring liquid into commode to remove black stains)',
            'Use cloth cleaning brush',
            'Use after cleaning spray room freshner'
        ],
        precautions: [
            'Wear gloves',
            'Use footwear avoid slips',
            'Wear a mask if needed',
            'Keep out of reach of children'
        ]
    },
    {
        id: 'blue-cleaner',
        name: 'YahYah Sparkle Blue',
        subtitle: 'Advanced Salt Cleaner for Stubborn Stains',
        description: 'Advanced Blue Salt Cleaner for stubborn stains. Ideal for removing hard salt stains from bathroom tiles, buckets, and floors.',
        price: '₹250',
        unit: '1 Litre',
        image: blueCleaner,
        banner: bannerBlue,
        color: 'from-blue-500 to-cyan-500',
        bgColor: 'from-blue-50 to-cyan-50',
        features: [
            'Remove hard cement marks',
            'Strong on dirt, safe on skin',
            'Smell free cleaning'
        ],
        useCases: [
            'Hard Salt Stains Cleaning',
            'Buckets & Doors Cleaning',
            'Tiles & Floor Cleaning',
            'Toilet Cleaning'
        ],
        instructions: [
            'Use green scrubber while cleaning',
            'Use steel scrubber',
            'Use sand paper (after pouring liquid into commode to remove black stains)',
            'Use cloth cleaning brush',
            'Use after cleaning spray room freshner'
        ],
        precautions: [
            'Wear gloves',
            'Use footwear avoid slips',
            'Wear a mask if needed',
            'Keep out of reach of children'
        ]
    }
];
